import { BACKEND_URL } from 'configs'
import { FetchClusteringStatusResponse } from 'tabs/topQuestions/types/ApiResponses'
import {
  FETCH_CLUSTERING_STATUS_FAILED,
  FETCH_CLUSTERING_STATUS_REQUEST,
  FETCH_CLUSTERING_STATUS_SUCCESS,
  FetchClusteringStatusFailed,
  FetchClusteringStatusRequest,
  FetchClusteringStatusSuccess,
} from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationTypes'


export const fetchCurrentClusteringStatus = (botId: number,
                                             clusteringStartPeriod: number,
                                             clusteringEndPeriod: number) => {
  return async (dispatch) => {
    try {
      dispatch(fetchClusteringStatusRequest())
      const uriSearchParams = new URLSearchParams()
      uriSearchParams.append('startPeriod', '' + clusteringStartPeriod)
      uriSearchParams.append('endPeriod', '' + clusteringEndPeriod)
      const response = await fetch(`${BACKEND_URL}/bot/${botId}/top-questions/clustering-status?${uriSearchParams.toString()}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      })
      const data = await response.json() as FetchClusteringStatusResponse
      dispatch(fetchClusteringStatusSuccess(data))
    } catch (error) {
      dispatch(fetchClusteringStatusFailed(error))
    }
  }
}


const fetchClusteringStatusFailed = (error: string): FetchClusteringStatusFailed => ({
  type: FETCH_CLUSTERING_STATUS_FAILED,
  payload: error,
})

const fetchClusteringStatusRequest = (): FetchClusteringStatusRequest => ({
  type: FETCH_CLUSTERING_STATUS_REQUEST,
  payload: undefined,
})
const fetchClusteringStatusSuccess = (data: FetchClusteringStatusResponse): FetchClusteringStatusSuccess => ({
  type: FETCH_CLUSTERING_STATUS_SUCCESS,
  payload: data,
})

